import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./CentreInformation.module.sass";
import Item from "../Item";
import TextInput from "../../../components/TextInput";
import { searchCenters } from "../../../services/center.service";

const CentreInformation = ({ className, onSelectCenter }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [showResults, setShowResults] = useState(false);

  // Effectuer la recherche lorsque la requête change
  useEffect(() => {
    const fetchCenters = async () => {
      if (searchQuery.length >= 2) {
        try {
          const results = await searchCenters(searchQuery);
          setSearchResults(results);
          setShowResults(true);
        } catch (error) {
          console.error('Erreur lors de la recherche des centres:', error);
          setSearchResults([]);
          setShowResults(false);
        }
      } else {
        setSearchResults([]);
        setShowResults(false);
      }
    };
    
    fetchCenters();
  }, [searchQuery]);

  // Gérer la sélection d'un centre
  const handleSelectCenter = (center) => {
    setSelectedCenter(center);
    setSearchQuery(center.name);
    setShowResults(false);
    
    // Transmettre le centre sélectionné au composant parent
    if (onSelectCenter) {
      onSelectCenter(center);
    }
  };

  // Gérer le changement dans la barre de recherche
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    if (selectedCenter && e.target.value !== selectedCenter.name) {
      setSelectedCenter(null);
    }
  };

  return (
    <Item
      className={cn(styles.card, className)}
      title="Centre de formation"
      classTitle="title-blue"
    >
      <div className={styles.fieldset}>
        <div className={styles.searchContainer}>
          <TextInput
            className={styles.field}
            label="Rechercher un centre de formation"
            name="center-search"
            type="text"
            placeholder="Nom du centre (min. 2 caractères)"
            tooltip="Recherchez par nom du centre de formation"
            value={searchQuery}
            onChange={handleSearchChange}
            required
          />
          
          {showResults && searchResults.length > 0 && (
            <div className={styles.searchResults}>
              {searchResults.map((center, index) => (
                <div 
                  key={center.id || index} 
                  className={styles.resultItem}
                  onClick={() => handleSelectCenter(center)}
                >
                  <div className={styles.resultContent}>
                    <img 
                      src={center.logoUrl || "/images/content/school_logo.png"} 
                      alt={center.name} 
                      className={styles.companyLogo} 
                    />
                    <div className={styles.companyInfo}>
                      <div className={styles.companyName}>{center.name}</div>
                      <div className={styles.companyDetails}>
                        <span>
                          {center.address}
                          {center.zip_code && center.city && `, ${center.zip_code} ${center.city}`}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {showResults && searchResults.length === 0 && searchQuery.length >= 2 && (
            <div className={styles.noResults}>
              Aucun centre de formation trouvé
            </div>
          )}
        </div>

        {selectedCenter && (
          <div className={styles.selectedCompanyDetails}>
            <h3>Détails du centre sélectionné</h3>
            <div className={styles.detailRow}>
              <span className={styles.label}>Nom:</span>
              <span className={styles.value}>{selectedCenter.name}</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.label}>Adresse:</span>
              <span className={styles.value}>
                {selectedCenter.address}
                {selectedCenter.address_complement && `, ${selectedCenter.address_complement}`}
                {selectedCenter.zip_code && selectedCenter.city && `, ${selectedCenter.zip_code} ${selectedCenter.city}`}
              </span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.label}>Téléphone:</span>
              <span className={styles.value}>{selectedCenter.phone || 'Non renseigné'}</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.label}>Email:</span>
              <span className={styles.value}>{selectedCenter.email || 'Non renseigné'}</span>
            </div>
          </div>
        )}
      </div>
    </Item>
  );
};

export default CentreInformation;